
import React, { useContext, useState, useEffect } from 'react';
import { useNavigate } from 'react-router-dom';
import MechanicCard from '../../../../../components/user/maintain/mechaniccard/MechanicCard.js';
import '../../../../../assets/css/user/maintainance/mechanics/Mechanic.css';
import mechanic1Img from '../../../../../assets/images/mechanic/mechanic1.jpg';
import mechanic2Img from '../../../../../assets/images/mechanic/mechanic2.jpg';
import mechanic3Img from '../../../../../assets/images/mechanic/mechanic3.jpg';
import mechanic4Img from '../../../../../assets/images/mechanic/mechanic4.jpg';
import AppContext from '../../../../../context/AppContext.js';
import axios from 'axios';

// ============================================
// MECHANIC SECTION COMPONENT (Homepage)
// ============================================
const Mechanic = () => {
  const { baseUrl, baseUrlForFile } = useContext(AppContext);
  const navigate = useNavigate();
  const [mechanics, setMechanics] = useState([]);

  const fetchMechanics = () => {
    axios
      .get(`${baseUrl}/customer/mechanics/fetchMechanics`)
      .then((res) => {
        console.log(res.data);
        if (res.data.success == true) {
          setMechanics(res.data.mechanic);
        }
      })
      .catch((err) => {
        console.log(err);
      });
  };

  const fetchSingleMechanic = () => {
    axios.get(`${baseUrl}/customer/detailmehanic/fetchSingleMechanic`)
      .then((response) => {
        console.log(response.data);
        if (response.data.success == true) {
          setMechanics(response.data.mechanic);
        }
      }).catch((error) => {
        console.log(error);
      });
  }

  useEffect(() => {
    console.log("log from the mechanic data");
    fetchMechanics();
  }, []);

  // Show only first 4 mechanics on homepage
  const topMechanics = [...mechanics]
    .sort((a, b) => (b.rating || 0) - (a.rating || 0))
    .slice(0, 4);


    const getImageUrl = (img) => {
  if (!img) return null;
  return `${baseUrlForFile}/storage/${img}`;
};

  // Book Mechanic Handler
  const handleBookMechanic = (mechanic) => {
    if (mechanic.status === 'busy') {
      alert('This mechanic is currently busy'); // 👈 simple UX
      return;
    }

    navigate(`/mechanic/${mechanic.id}`);
  };

  // View Details Handler
  const handleViewDetails = (mechanicId) => {
    navigate(`/mechanic/${mechanicId}`);
  };

  // Show More Handler
  const handleShowMore = () => {
    navigate('/mechanics');
  };

  return (
    <section className="professional-mechanics-section">
      <div className="container">
        {/* Section Heading */}
        <div className="section-header">
          <h2 className="section-heading">
            Our Professional <span className="highlight-word">MECHANICS</span>
          </h2>
        </div>

        {/* Mechanics Grid */}
        <div className="mechanics-row">
          {topMechanics.map((mechanic) => (
            <div key={mechanic.id} className="mechanic-col">
              <MechanicCard
                mechanic={mechanic}
                onBookClick={handleBookMechanic}
                onViewDetails={handleViewDetails}
              />
            </div>
          ))}
        </div>

        {/* Show More Button */}
        <div className="show-more-container">
          <button className="show-more-btn" onClick={handleShowMore}>
            Show More Mechanics
            <span className="arrow-icon">→</span>
          </button>
        </div>
      </div>
    </section>
  );
};

export default Mechanic;